import React, { FC, useEffect, useRef, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { creditcardDataStore } from 'src/store/creditcard';
import { fetchDeleteCardData } from 'src/fetch/stepC/card';
import { initDataStore } from 'src/store/taxData';
import {
  confirmModalViewStore,
  contentModalDep2ViewStore,
  errorModalViewStore,
  loadingModalViewStore,
} from 'src/store/modal';
import { defaultData } from 'src/static/sample/creditData';
import CheckBox from 'src/components/atoms/CheckBox';
import TaxTopButton from 'src/components/organisms/template/StepC/template/TaxModal/TaxTopButton';
import TaxBottomDesc from 'src/components/organisms/template/StepC/template/TaxModal/TaxBottomDesc';
import GridList from './list';
import UpsertGrid from './upsert';
import '../tableRef.scss';
import './style.scss';

interface Props {
  cardType: any;
}
const CreditGrid: FC<Props> = ({ cardType }) => {
  const queryClient = useQueryClient();
  const errorModalState = errorModalViewStore((state: any) => state.set);
  const loadingState = loadingModalViewStore((state: any) => state.set);

  const bindCreditCardParam = creditcardDataStore((state: any) => state.param);
  const bindCreditCardBindParam = creditcardDataStore((state: any) => state.bindParam);

  const setContentModalState = contentModalDep2ViewStore((state: any) => state.set);
  const setConfirmModalState = confirmModalViewStore((state: any) => state.set);
  const closeModalState = confirmModalViewStore((state: any) => state.close);

  const cardData = creditcardDataStore((state: any) => state.result).data || [];
  const dataSet = cardData.filter((item: any) => item.creditCard !== undefined);

  let viewData: any = [];
  let cardName = '신용카드';
  let dataType = 'G0012';

  if (cardType === 'credit') {
    dataType = 'G0012';
    cardName = '신용카드';
  } else if (cardType === 'debit') {
    dataType = 'G0014';
    cardName = '직불카드';
  } else if (cardType === 'cash') {
    dataType = 'G0013';
    cardName = '현금영수증';
  } else if (cardType === 'zero') {
    dataType = 'G0014B';
    cardName = '제로페이';
  }

  dataSet.forEach((item: any) => {
    const itemCard = item.creditCard || [];
    item.cardData = itemCard.find((card: any) => card.data_type === dataType);
  });
  viewData = dataSet.filter((item: any) => item.cardData?.data_type === dataType);

  //:State
  const [viewTypeState, setViewTypeState] = useState({ type: '' });
  useEffect(() => {
    setViewTypeState({ type: '' });
  }, [cardType]);

  // ADD
  const addClickEvent = () => {
    const payload = {
      active: '_active',
      title: cardName + ' 내역 추가',
      content: (
        <div className="_creditcard_layout">
          <div className="_add_list_grid">
            <div className="_add_div">
              <UpsertGrid cardType={cardType} type="insert" />
            </div>
          </div>
        </div>
      ),
      styleDef: { width: '1024px' },
    };
    setContentModalState(payload);
  };

  // Modify
  const modifyClickEvent = () => {
    viewTypeState.type === ''
      ? setViewTypeState({ type: 'modify' })
      : setViewTypeState({ type: '' });
  };
  const modifyItemEvent = (item: any) => {
    const payload = {
      active: '_active',
      title: cardName + ' 내역 수정',
      content: (
        <div className="_creditcard_layout">
          <div className="_add_list_grid">
            <div className="_add_div">
              <UpsertGrid cardType={cardType} type="update" data={item} />
            </div>
          </div>
        </div>
      ),
      styleDef: { width: '1024px' },
    };
    setContentModalState(payload);
  };

  // Delete
  const deleteItemEvent = (selItem: any) => {
    const confirmDiv = () => {
      return (
        <div className="_confirm_modal_content">
          <div className="_title">'{selItem.name || ''}'님의 내용을 삭제합니다.</div>
          {/* <div className="_desc">삭제시 메뉴에 포함된 모든 데이터가 삭제됩니다.</div> */}
          <div className="_desc">내용을 삭제 하시겠습니까?</div>
        </div>
      );
    };
    setConfirmModalState({
      active: '_active',
      content: confirmDiv(),
      cancleEvt: (item: any) => {
        closeModalState({ content: null, active: '' });
      },
      confirmEvt: (item: any) => {
        // Fetch Data
        const param = {
          acct_year: selItem.cardData?.acct_year,
          co_cd: selItem.cardData?.co_cd,
          co_id: selItem.cardData?.co_id,
          family_seqid: selItem.cardData?.family_seqid,
          in_data_seqid: selItem.cardData?.in_data_seqid,
        };
        // return false;
        fetchDeleteCardData(param, queryClient, errorModalState, loadingState, () => {
          const initialSeq = bindCreditCardParam.initialSeq || 0;
          bindCreditCardBindParam({ initialSeq: initialSeq + 1 });
          setContentModalState({
            active: '',
          });
        });

        //Close
        closeModalState({ content: null, active: '' });
      },
    });
  };

  const listGrid = () => {
    return (
      <div className="_list_grid">
        <TaxTopButton
          addClickEvt={addClickEvent}
          modifyClickEvt={modifyClickEvent}
          viewType={viewTypeState.type}
        />
        {viewData.length === 0 ? (
          <div className="_no_content">
            <div className="_txt">조회된 데이터가 없습니다.</div>
            <div className="_desc">사용한 카드 내역을 추가 할 수 있습니다.</div>
          </div>
        ) : (
          <>
            <GridList
              data={viewData}
              viewType={viewTypeState.type}
              modifyItemEvt={modifyItemEvent}
              deleteItemEvt={deleteItemEvent}
            />
            <TaxBottomDesc />
          </>
        )}
      </div>
    );
  };

  return <div className="_creditcard_layout">{listGrid()}</div>;
};

export default CreditGrid;
